import { useState, useMemo } from 'react';

export const useChatFiltering = (chats) => {
  const [showingArchived, setShowingArchived] = useState(false);

  const { activeChats, archivedChats, displayedChats } = useMemo(() => {
    const active = chats.filter(chat => !chat.archived);
    const archived = chats.filter(chat => chat.archived);
    const displayed = showingArchived ? archived : active;

    return {
      activeChats: active,
      archivedChats: archived,
      displayedChats: displayed
    };
  }, [chats, showingArchived]);

  return {
    showingArchived,
    setShowingArchived,
    activeChats,
    archivedChats,
    displayedChats
  };
};